import { AsyncPipe, isPlatformServer } from '@angular/common';
import { ChangeDetectionStrategy, Component, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { firstValueFrom, switchMap } from 'rxjs';
import { CanDisplayAssetPipe } from '../../../gallery-shared/pipes/can-display-asset.pipe';
import { getAllRouteData } from '../../../lib/get-all-route-data';
import { getAllRouteParams } from '../../../lib/get-all-route-params';
import { AssetService } from '../../../services/asset.service';
import { GuestAuthService } from '../../../services/guest-auth.service';
import { GuestService } from '../../../services/guest.service';
import { UserService } from '../../../services/user.service';
import { WatcherService } from '../../../services/watcher.service';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { ResizeDirective } from '../../../shared/directives/resize.directive';
import { AssetUrlPipe } from '../../../shared/pipes/asset-url.pipe';
import { FailedAssetVersionUrlPipe } from '../../../shared/pipes/failed-asset-version-url.pipe';

@Component({
  selector: 'app-subscribe-to-asset-page',
  templateUrl: './subscribe-to-asset-page.component.html',
  styleUrls: ['./subscribe-to-asset-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeaderComponent,
    RouterLink,
    ResizeDirective,
    ButtonDirective,
    SvgComponent,
    AssetUrlPipe,
    AsyncPipe,
    FailedAssetVersionUrlPipe,
    CanDisplayAssetPipe,
  ],
})
export class SubscribeToAssetComponent {
  private route = inject(ActivatedRoute);
  private watcherService = inject(WatcherService);
  private userService = inject(UserService);
  private guestService = inject(GuestService);
  private guestAuthService = inject(GuestAuthService);
  private assetService = inject(AssetService);
  private platformId = inject<string>(PLATFORM_ID);
  asset$ = this.route.params.pipe(
    switchMap(() => {
      const data = getAllRouteParams(this.route.snapshot);
      return this.assetService.getAssetObservable(data.assetId, data.galleryId);
    })
  );
  gallery: GalleryDto;
  constructor() {
    const data = getAllRouteData(this.route.snapshot);

    this.gallery = data.gallery;

    if (isPlatformServer(this.platformId)) return;
    this.init();
  }

  async init() {
    const user = await firstValueFrom(this.userService.getUser());
    const guest = await this.guestService.getGuest();

    if (!user && !guest) {
      const resp = await this.guestAuthService.authenticateWithPopup(this.gallery);
      if (!resp) return false;
    }
    this.watcherService.watchAsset$.next({
      assetId: getAllRouteParams(this.route.snapshot).assetId,
      gallery: this.gallery,
    });
  }
}
